import { scrollToBlock } from '@fttb/common/utils';
import { getViewStatus } from "../moduleSelectors";
import { selectAnchorId } from "../selectors";
import { AVAILABLE_STEPS, CHECK_ANOTHER_ADDRESS_STEPS } from "../constants";
import { backToCheckAddressStep } from "../slice";
import { handleIsNotAvailableStep } from "./analytics";
export var handleSecondaryButtonClick = function handleSecondaryButtonClick() {
  return function (dispatch, getState) {
    var state = getState();
    var step = getViewStatus(state);
    var anchorId = selectAnchorId(state);
    dispatch(handleIsNotAvailableStep({
      isSecondaryButton: true
    }));
    if (CHECK_ANOTHER_ADDRESS_STEPS.includes(step)) {
      dispatch(backToCheckAddressStep());
    }
    if (AVAILABLE_STEPS.includes(step)) {
      scrollToBlock(anchorId);
    }
  };
};